<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/policies">Policies</router-link>
                    </li>
                    <template v-if="!policy.id">
                        <vue-headful :title="'[Create Policy] - AMOS365'" />

                        <li class="breadcrumb-item active" aria-current="page">Create Policy</li>
                    </template>
                    <template v-else>
                        <vue-headful :title="'[Edit Policy] - AMOS365'" />
                        <li class="breadcrumb-item">
                            <router-link :to="`/policies/view/${policy.id}`">{{ (policy.policy_number ? policy.policy_number : policy.product_name+' for '+policy.client_name) }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Edit</li>
                    </template>

                </ol>
            </nav>

            <h4 class="page-header">
                <span v-if="id">Edit Policy</span>
                <span v-else>New Policy</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.product_id, 'text-muted-no': !errors.product_id}">
                                    Product: <i class="fa fa-sm fa-asterisk text-danger" v-if="!policy.product_id"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <v-select
                                        v-model="policy.product_id"
                                        :options="products"
                                        :reduce="product => product.id"
                                        label="product_name"
                                        :class="{'is-invalid': errors.product_id}"
                                        placeholder="-- Select a Product --" />

                                    <div class="text-danger mt-2" v-if="errors.product_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.product_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.agent_id}">
                                    Agent:  <i class="fa fa-sm fa-asterisk text-danger" v-if="!agent_id"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">

                                    <v-select
                                        v-model="policy.agent_id"
                                        :options="agents"
                                        :reduce="agent => agent.id"
                                        label="agent_name"
                                        :class="{'is-invalid': errors.agent_id}"
                                        placeholder="-- Select an Agent --"
                                        @search="searchAgents"
                                        :filterable="false" />

                                    <div class="text-danger mt-2" v-if="errors.agent_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.agent_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.client_id}">
                                    Client:  <i class="fa fa-sm fa-asterisk text-danger" v-if="!client_id"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">

                                    <v-select
                                        v-model="policy.client_id"
                                        :options="clients"
                                        :reduce="agent => agent.id"
                                        label="client_name"
                                        :class="{'is-invalid': errors.client_id}"
                                        placeholder="-- Select an Client --"
                                        @search="searchClients"
                                        :filterable="false" />

                                    <div class="text-danger mt-2" v-if="errors.client_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.client_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">Policy Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="policy.is_active" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_active">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.is_active">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_spouse_policy, 'text-muted-no': !errors.is_spouse_policy}">Spouse Policy:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="policy.is_spouse_policy" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_spouse_policy">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.is_spouse_policy">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.policy_number, 'text-muted-no': !errors.policy_number}">Policy#:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="policy.policy_number" :class="{'form-control': true, 'is-invalid': errors.policy_number}" placeholder="Enter Policy Number" />

                                    <div class="text-danger mt-2" v-if="errors.policy_number">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.policy_number">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <hr/>

                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.face_amount, 'text-muted-no': !errors.face_amount}">Face Amount:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="policy.face_amount" :class="{'form-control': true, 'is-invalid': errors.face_amount}" placeholder="Enter Face Amount" />

                                    <div class="text-danger mt-2" v-if="errors.face_amount">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.face_amount">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.monthly_payment, 'text-muted-no': !errors.monthly_payment}">Monthly Payment:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="policy.monthly_payment" :class="{'form-control': true, 'is-invalid': errors.monthly_payment}" placeholder="Enter Monthly Payment" />

                                    <div class="text-danger mt-2" v-if="errors.monthly_payment">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.monthly_payment">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.annual_payment, 'text-muted-no': !errors.annual_payment}">Annual Payment:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="policy.annual_payment" :class="{'form-control': true, 'is-invalid': errors.annual_payment}" placeholder="Enter Annual Payment" />

                                    <div class="text-danger mt-2" v-if="errors.annual_payment">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.annual_payment">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <hr/>

                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.entered_date, 'text-muted-no': !errors.entered_date}">Entered Date:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="policy.entered_date" :class="{'form-control': true, 'is-invalid': errors.entered_date}" placeholder="Enter Entered Date" />

                                    <div class="text-danger mt-2" v-if="errors.entered_date">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.entered_date">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.effective_date, 'text-muted-no': !errors.effective_date}">Effective Date:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="policy.effective_date" :class="{'form-control': true, 'is-invalid': errors.effective_date}" placeholder="Enter Effective Date" />

                                    <div class="text-danger mt-2" v-if="errors.effective_date">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.effective_date">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.signature_date, 'text-muted-no': !errors.signature_date}">Signature Date:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="policy.signature_date" :class="{'form-control': true, 'is-invalid': errors.signature_date}" placeholder="Enter Signature Date" />

                                    <div class="text-danger mt-2" v-if="errors.signature_date">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.signature_date">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Notes</strong>
                        </div>
                        <div class="card-body">
                            <b-form-textarea v-model="policy.notes" :class="{'is-invalid': errors.notes}" placeholder="Enter Policy Notes" rows="3"></b-form-textarea>
                        </div>
                    </div>

                    <files-add ref="policyEditFiles" />
                </div>
            </div>

            <div class="">
                <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="savePolicy()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Create</template>
                </button>
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="savePolicy()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                policy: {},
                products: [],
                agent_id: null,
                errors: {},
                agents: [],
                clients: [],
                files: [],
            }
        },

        watch: {

        },

        computed: {
            stateOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a State --'}];

                //Main Loop
                for(var i = 0; i < this.states.length; i++)
                {
                    options.push({value: this.states[i].id, text: this.states[i].state_name});
                }

                //Send it
                return options;
            },

            levels(){
                //Check for empty product
                if(!this.policy.product_id)
                {
                    return [];
                }

                //Loop and Check
                for (var i = this.policies.length - 1; i >= 0; i--)
                {
                    //Check it
                    if(this.policies[i].id === this.policy.product_id)
                    {
                        return this.policies[i].levels;
                    }
                }

                return [];
            },
        },

        methods: {

            getPolicy(){
                //Send it
                this.$http.get('/policies/edit' + (this.id ? '/'+this.id : ''), this.$route.query)
                    .then(response => {
                        //Set the policy
                        this.policy = response.data.policy;
                        this.products = response.data.products;

                        //Check for Agent
                        if(this.policy.agent_id)
                        {
                            //Push
                            this.agents.push({id: this.policy.agent_id, agent_name: this.policy.agent_name});
                        }

                        //Check for Client
                        if(this.policy.client_id)
                        {
                            //Push
                            this.clients.push({id: this.policy.client_id, client_name: this.policy.client_name});
                        }
                    })
                    .catch(error => {
                        //Log it
                        console.log(error);

                        //Alert the user
                        this.$toastr.e(error);
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            savePolicy(){
                //Helpers
                this.saving = true;
                this.errors = {};

                //Get it
                var file_data = this.$refs.policyEditFiles.getFilesForSave();

                //Set
                this.policy.file_names = file_data.file_names;

                //Send it
                this.$http
                .postWithFiles('/policies/save', this.policy, file_data.files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Policy ' + (this.policy.id ? 'Updated' : 'Created') );

                    //Return to main list?
                    this.$router.push('/policies/view/' + response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Set the errors to the file helper
                        this.$refs.policyEditFiles.setErrors(this.errors);

                        //Alert
                        this.$toastr.e('Validation Errors');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Policy');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            searchAgents(search, loading){
                //Minimum 3 characters
                if(search.length < 3)
                {
                    //Display an Alert?

                    //STop
                    return;
                }

                //Must call this to let VueSelect know what we are doing
                loading(true);

                //Build the Search Payload
                var payload = {
                    query: search,
                    limit: 20,
                    ascending: 1,
                    page: 1,
                    byColumn: 0,
                    orderBy: 'agents.last_name',
                    typeahead: true,
                };

                //Show a Loading INdicator?
                this.$http.get('/agents', payload)
                        .then(response => {
                            loading(false);

                            // //Set the Data
                            // var agents = response.data.data;

                            // //Loop and Build
                            // for (var i = 0; i < response.data.data.length; i++)
                            // {
                            //     agents.push({id: response.data.data[i].id, agent_name: (response.data.data[i].first_name + ' ' + response.data.data[i].last_name)})
                            // }

                            // //Set the values
                            this.agents = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .then(() => {

                        })
            },

            searchClients(search, loading){
                //Minimum 3 characters
                if(search.length < 3)
                {
                    //Display an Alert?

                    //STop
                    return;
                }

                //Must call this to let VueSelect know what we are doing
                loading(true);

                //Build the Search Payload
                var payload = {
                    query: search,
                    limit: 20,
                    ascending: 1,
                    page: 1,
                    byColumn: 0,
                    orderBy: 'clients.last_name',
                    typeahead: true,
                };

                //Show a Loading INdicator?
                this.$http.get('/clients', payload)
                        .then(response => {
                            //Set the loading Indicator
                            loading(false);

                            //Set the values
                            this.clients = response.data.data;
                        })
                        .catch(error => {
                            //Debugging
                            console.log(error);
                        })
                        .then(() => {

                        })
            }
        },

        mounted() {
            //get the policy?
            this.getPolicy();
        }
    }
</script>